import { useMutation, useQueryClient } from '@tanstack/react-query';

import { partnersApiKeys } from '@/api/routes/partners/partners.api';
import { partnersInvitesApi } from '@/api/routes/partners/partners.invites.api';

/**
 * Accept a partner invite. The invite page turns 403/404/409 into its own states, so the global
 * snackbar stays quiet; on success the new link becomes the current account at once.
 */
export const usePartnersAcceptInvite = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (token: string) => partnersInvitesApi.accept(token).then((res) => res.data),
    meta: { showUserMessage: false },
    onSuccess: (account) => {
      queryClient.setQueryData(partnersApiKeys.me(), account);
      return queryClient.invalidateQueries({ queryKey: partnersApiKeys.all });
    },
  });
};
